import { apiFunction } from "../../apiCall/function";
import { ADMIN_LOGIN } from "../../apiCall/urls/auth";
import * as URLs from "../../apiCall/urls/auth";
export const handleLogin = (data) => {
  return apiFunction(ADMIN_LOGIN, "post", data, null, null);
};

//ADMIN
export const getStateDistrict = (data) => {
  return apiFunction(
    URLs.STATE_DISTRICT,
    "post",
    data,
    true,
    null,
    "AuthAdmin"
  );
};
export const getStateBlock = (id, session) => {
  return apiFunction(
    URLs.STATE_BLOCK + "/" + id,
    "post",
    {
      sessionId: session,
    },
    true,
    null,
    "AuthAdmin"
  );
};

export const getStateSchool = (data, blockId) => {
  return apiFunction(
    URLs.STATE_SCHOOL + "/" + blockId,
    "post",
    { sessionId: data },
    true,
    null,
    "AuthAdmin"
  );
};

export const getStateStudent = (data, schoolId) => {
  return apiFunction(
    URLs.STATE_STUDENT + "/" + schoolId,
    "post",
    data,
    true,
    null,
    "AuthAdmin"
  );
};


export const getDivisionStudent = (data, schoolId) => {
  return apiFunction(
    URLs.DIVISION_STUDENT + "/" + schoolId,
    "post",
    data,
    true,
    null,
    "AuthAdmin"
  );
};

export const getStateStudentId = (studentId) => {
  return apiFunction(
    URLs.STATE_STUDENT_ID + "/" + studentId,
    "post",
    {},
    true,
    null,
    "AuthAdmin"
  );
};

//DEO
export const getDistrictBlock = (data) => {
  return apiFunction(
    URLs.DISTRICT_BLOCK,
    "post",
    { sessionId: data },
    true,
    null,
    "AuthAdmin"
  );
};

export const getDistrictSchool = (data, blockId) => {
  return apiFunction(
    URLs.DISTRICT_SCHOOL + "/" + blockId,
    "post",
    { sessionId: data },
    true,
    null,
    "AuthAdmin"
  );
};

export const getDistrictStudent = (data, schoolId) => {
  return apiFunction(
    URLs.DISTRICT_STUDENT + "/" + schoolId,
    "post",
    data,
    true,
    null,
    "AuthAdmin"
  );
};

export const getDistrictStudentId = (studentId) => {
  return apiFunction(
    URLs.DISTRICT_STUDENT_ID + "/" + studentId,
    "post",
    {},
    true,
    null,
    "AuthAdmin"
  );
};

export const getDistrictSchoolData = (session) => {
  return apiFunction(
    URLs.GET_DISTRICT_SCHOOL,
    "post",
    {
      sessionId: session,
    },
    true,
    null,
    "AuthAdmin"
  );
};
export const getDistrictSchoolDataNew = (session, page = 1, limit = 10, search = "") => {
  return apiFunction(
    URLs.GET_DISTRICT_SCHOOL_NEW,
    "post",
    {
      sessionId: session,
      page,
      limit,
      search,
    },
    true,
    null,
    "AuthAdmin"
  );
};

export const updateDistrictEmail = (data) => {
  return apiFunction(
    URLs.UPDATE_EMAIL_DISTRCT,
    "post",
    data,
    true,
    null,
    "AuthAdmin"
  );
};

export const getSchoolSeats = (id) => {
  return apiFunction(
    URLs.GET_SCHOOL_SEATS + id,
    "get",
    null,
    true,
    null,
    "AuthAdmin"
  );
};


export const approveSeats = (data) => {
  return apiFunction(URLs.APPROVE_SEATS, "post", data, true, null, "AuthAdmin");
};

export const rejectSeats = (data) => {
  return apiFunction(URLs.RECHECK_SEATS, "post", data, true, null, "AuthAdmin");
};

//school List  BY DEO 
export const getSchoolDetailsById = (schoolId) => {
  return apiFunction(URLs.GET_SCHOOL_DETAILS +schoolId, "GET", null, true, null, "AuthAdmin")
}

//  APPROVE_SCHOOL_DETAILS
export const approveSchoolDetails = (data)=>{
  return apiFunction(URLs.APPROVE_SCHOOL_DETAILS,"POST",data,true,null,"AuthAdmin");
}

// REJECT_SCHOOL_DETAILS
export const rejectSchoolDetails = (data)=>{
  return apiFunction(URLs.REJECT_SCHOOL_DETAILS,"POST",data,true,null,"AuthAdmin")
}







//BEO
export const getBlockSchool = (data) => {
  return apiFunction(
    URLs.BLOCK_SCHOOL,
    "post",
    { sessionId: data },
    true,
    null,
    "AuthAdmin"
  );
};

export const getBlockStudent = (data, schoolId) => {
  return apiFunction(
    URLs.BLOCK_STUDENT + "/" + schoolId,
    "post",
    data,
    true,
    null,
    "AuthAdmin"
  );
};

export const getBlockStudentId = (studentId) => {
  return apiFunction(
    URLs.BLOCK_STUDENT_ID + "/" + studentId,
    "post",
    {},
    true,
    null,
    "AuthAdmin"
  );
};

//School
export const getSchoolStudent = (data) => {
  return apiFunction(
    URLs.SCHOOL_STUDENT,
    "post",
    data,
    true,
    null,
    "AuthAdmin"
  );
};

export const getSchoolStudentId = (studentId) => {
  return apiFunction(
    URLs.SCHOOL_STUDENT_ID + "/" + studentId,
    "post",
    {},
    true,
    null,
    "AuthAdmin"
  );
};

export const viewSchoolSeats = () => {
  return apiFunction(
    URLs.VIEW_SCHOOL_SEATS,
    "get",
    {},
    true,
    null,
    "AuthAdmin"
  );
};
export const addSchoolSeats = (data) => {
  return apiFunction(
    URLs.ADD_SCHOOL_SEATS,
    "post",
    data,
    true,
    null,
    "AuthAdmin"
  );
};
export const updateSchoolSeats = (data) => {
  return apiFunction(
    URLs.UPDATE_SCHOOL_SEATS,
    "put",
    data,
    true,
    null,
    "AuthAdmin"
  );
};

export const deleteSchoolSeats = (id) => {
  return apiFunction(
    URLs.DELETE_SCHOOL_SEATS + id,
    "delete",
    null,
    true,
    null,
    "AuthAdmin"
  );
};

//GET_DASBOARD_DATA
export const getDashboardData = (data) => {
  let url = URLs.DISTRICT_DASHBOARD;
  if (data === "block") {
    url = URLs.BLOCK_DASHBOARD;
  } else if (data === "school") {
    url = URLs.SCHOOL_DASHBOARD;
  }
  return apiFunction(url, "get", data, true, null, "AuthAdmin");
};

//rediect to payment page
export const paymentAPi = (data) => {
  return apiFunction(URLs.PAYMET_URL, "get", data, true, null, "AuthAdmin");
};


